module.exports = __webpack_public_path__ + "static/uxfellows-215cab47330610a1491ee3eaedf40ae3.png";